import { Lightning } from '@lightningjs/sdk';
import merge from 'lodash/merge';
import { getInitialStyle, getCheckedStyle, getDisabledStyle } from './checkbox.style';
import Icon from '../../modules/tornado/icon/icon.component';

export class Checkbox extends Lightning.Component {
  static _template() {
    return merge(
      {
        Border: {
          type: Lightning.components.BorderComponent,
        },
        Icon: {
          type: Icon,
        },
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._checked = false;
    this._disabled = false;
  }

  set checked(value) {
    this._checked = value;
    this.patch(value ? getCheckedStyle() : getInitialStyle());
  }

  set disabled(value) {
    this._disabled = value;
    this.patch(value ? getDisabledStyle() : getInitialStyle());
  }
}
